import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';

import { injectSupplySlice } from '@/app/supplyApi';
import { toUser } from '@/features/auth/toUser';
import { User } from '@/features/auth/types';

export const authApi = injectSupplySlice({
  baseUrl: '',
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getCurrentUser: builder.query<User, void>({
      query: () => ({
        url: '/user',
      }),
      transformResponse: toUser,
    }),
  }),
});

export const { useLazyGetCurrentUserQuery } = authApi;
